import { Check, Minus } from "lucide-react";
import { Reveal } from "../components/Reveal";
import CtaButton from "../components/CtaButton";

const PASST = [
  "Sie an eine klar benennbare Gruppe verkaufen: wenige hundert bis ca. 5.000 Entscheider im DACH-Raum",
  "Ihre Entscheider auf LinkedIn aktiv sind",
  "ein neuer Kunde für Sie 50.000 € oder mehr wert ist",
  "Sie als Geschäftsführer, Inhaber oder Partner selbst entscheiden und unter eigenem Namen auftreten",
  "Sie mit sechs Monaten Laufzeit planen können"
];

const PASST_NICHT = [
  "Sie an alle KMU oder an Privatkunden verkaufen",
  "Ihre Zielgruppe LinkedIn kaum nutzt",
  "ein neuer Kunde für Sie deutlich unter 50.000 € wert ist",
  "Sie die Kampagne an Ihr Marketing delegieren möchten",
  "Sie Ergebnisse innerhalb weniger Wochen brauchen"
];

export default function Passt() {
  return (
    <section className="bg-hellblau py-20 sm:py-28 lg:py-32">
      <div className="mx-auto max-w-6xl px-5 sm:px-8">
        <Reveal>
          <div className="flex items-center gap-4">
            <span className="h-px w-10 bg-navy/40" />
            <p className="text-xs font-semibold uppercase tracking-[0.25em] text-textgrau">Für wen es passt</p>
          </div>
          <h2
            className="mt-6 max-w-3xl text-2xl font-medium leading-snug tracking-[-0.01em] text-textdunkel sm:text-3xl lg:text-4xl"
            data-testid="passt-ueberschrift"
          >
            Wir arbeiten mit wenigen Kunden. Deshalb sind wir wählerisch.
          </h2>
        </Reveal>

        <div className="mt-14 grid gap-4 lg:grid-cols-2">
          <Reveal>
            <div className="h-full rounded-[2px] bg-white p-8 sm:p-10" data-testid="passt-ja">
              <p className="text-xs font-semibold uppercase tracking-[0.2em] text-textgrau">Passt, wenn</p>
              <ul className="mt-2 divide-y divide-navy/10">
                {PASST.map((p, i) => (
                  <li key={p} className="flex items-start gap-4 py-4" data-testid={`passt-ja-${i + 1}`}>
                    <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-gruen/10 text-gruen">
                      <Check size={13} strokeWidth={2.5} />
                    </span>
                    <span className="text-sm leading-[1.8] text-textdunkel sm:text-base">{p}</span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="h-full rounded-[2px] bg-white p-8 sm:p-10" data-testid="passt-nein">
              <p className="text-xs font-semibold uppercase tracking-[0.2em] text-textgrau">Passt nicht, wenn</p>
              <ul className="mt-2 divide-y divide-navy/10">
                {PASST_NICHT.map((p, i) => (
                  <li key={p} className="flex items-start gap-4 py-4" data-testid={`passt-nein-${i + 1}`}>
                    <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-navy/5 text-textgrau">
                      <Minus size={13} strokeWidth={2.5} />
                    </span>
                    <span className="text-sm leading-[1.8] text-textgrau sm:text-base">{p}</span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>

        <Reveal>
          <p className="mt-14 max-w-3xl text-base leading-[1.85] text-textdunkel" data-testid="passt-preis">
            Die Zusammenarbeit beginnt ab 3.000 € im Monat bei einer Laufzeit ab sechs Monaten. Sie rechnet sich, wenn
            ein neuer Kunde für Sie 50.000 € oder mehr wert ist.
          </p>
          <div className="mt-9">
            <CtaButton testid="cta-passt" />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
